import type { PlatformFeatureAccess } from 'src/utils/platform-features';

import type { AnyTool } from './tool-types';

/**
 * Whether the platform's edition has the tool at all. Unlike the permission and tariff
 * guards this is not a verdict to explain: an unavailable tool is filtered out of the
 * registry the model sees, so the assistant never learns the feature exists.
 */
export const isToolAvailable = (tool: AnyTool, features: PlatformFeatureAccess): boolean =>
  features.isResourceAvailable(tool.permission.resource) &&
  (!tool.platformFeature || features.isFeatureEnabled(tool.platformFeature));
